import { FireDepartmentInput } from "generated-graphql/graphql";

export function transform(input: FireDepartmentInput): FireDepartmentInput {
  return {
    ...input,
    latitude: input.latitude ? Number(input.latitude) : null,
    longitude: input.longitude ? Number(input.longitude) : null,
  };
}
